import { ValidationResultEntry } from './validation-error';

export interface ValidationResult {
  Name: string;
  ValidationResults: ValidationResultEntry[];
  Status: ValidationStatusEnum;
  Type: ValidationResultType;
}

export enum ValidationStatusEnum {
  Success = 0,
  Error = 1,
  Warning = 2,
}
export enum ValidationResultType {
  PreValidate = 0,
  Validate = 1,
}
